import * as React from 'react';

/** @deprecated Work with your designer to replace with one of the current illustrations (https://lens.loom.dev/illustrations/illustration-set). */
function IllustrationFaQandSecurity(props) {
  return (
    <svg
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M50 70c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20z"
        fill="currentColor"
      />
      <path d="M31 50V0H0v100h99.999V69H31V50z" fill="currentColor" />
      <path d="M100 66V0H34v31h35v35h31z" fill="currentColor" />
    </svg>
  );
}

export default IllustrationFaQandSecurity;
